<template>
    <div  class="ep-form-toolbar" style="padding-left: 50px; padding-right: 50px;">
               
                <div id="root_combo_filter" class="form-group"  v-if="header_filters_active && (header_filters_active['multiple_combo'] || header_filters_active['combo'])">
                    <!-- <div class="pull-left col-md-1 col-xs-1" style="min-height:54px;" v-if="header_status_.text_filter!==null">
                        <label for="root_combo_filter"><span> </span></label>
                        <div class="" style="    bottom: 0px;position: absolute;"><span class="fa fa-search " style="font-size: 16px;"></span></div>
                    </div> -->
                    <!-- <div class="pull-left"> -->
                        <label for="root_combo_filter">{{header_filters_active['combo_name']}}</label>
                        <select id="root_combo_filter" class="form-control" v-on:select="header_status_.leaf_combo_filter=''"  aria-placeholder="Seleziona opzione ..."  v-model="header_status_.root_combo_filter">
                            <option selected value="">Seleziona opzione ...</option>
                            <option v-for="option in header_status_.combo_filter_values" :value="option" :key="option.value">{{option.key}}</option>
                        </select>
                    <!-- </div> -->
                </div>
                
                <div id="leaf_combo_filter" class="form-group" v-if="header_status_.root_combo_filter && childsExist && header_filters_active['multiple_combo']">
                    <label for="leaf_combo_filter">Settore</label>
                    <select id="leaf_combo_filter" class="form-control" v-model="header_status_.leaf_combo_filter">
                        <option selected value="">Seleziona opzione ...</option>
                        <option v-for="ops in childrens" :value="ops" :key="ops.value">{{ops.key}}</option>
                    </select>
                </div>
                <div class="form-group" v-if="header_filters_active && header_filters_active['text']">
                    <label for="root_combo_filter">Testo</label>
                    <input type="text" class="form-control" v-model="header_status.text_filter" v-on:keydown="keydown($event)" placeholder="Testo libero">
                </div>


<!--         <div class="col-md-6 ep-tools-title" v-show="header_status_.panel_open">
            <span class="fa fa-question pull-right"></span>
            <span class="pull-right">{{header_status_.help_message}}</span>
        </div> -->
         

    </div>
</template>

<script>
import { status_values } from '../../utils/env';

export default {
    name:'DashPanelHeader',
    props:  {
        header_status: {type: Object, value: {combo_filter_values: null, help_message: null, text_filter: null, root_combo_filter: null, leaf_combo_filter: null}},
        header_filters_active: {type: Object, value: {'text': false, 'combo': false, 'multiple_combo': false}},
        dash_panel_opened: {type: Boolean, value: false},
        task: {type: Object, value: null}
    },
    data: function() { 
        return {
            root_combo_filter: this.header_status.root_combo_filter,
            leaf_combo_filter: this.header_status_leaf_combo_filter,
            text_filter: this.header_status.text_filter,
            typingTimer: null,
            doneTypingInterval: 4000,
            status_values: status_values,
            header_status_: this.header_status,
        }
    },
    watch: {
        'header_status_': {
            handler() {
                this.$root.header_status = this.header_status_;
                console.log('HANDLER');
            },
            deep: true
        },
        'root_combo_filter': function() {
            this.header_status_.leaf_combo_filter = "";
            this.header_status_.root_combo_filter = this.root_combo_filter.value;
        },
        'leaf_combo_filter': function() {
            this.header_status_.leaf_combo_filter = this.leaf_combo_filter.value;
        },
    },
    methods:  {
        keydown: function() {
            if (this.typingTimer!=null) {
                clearTimeout(this.typingTimer);
                this.typingTimer = null;
            } else {
                this.typingTimer = setTimeout(this.doneTyping(), this.doneTypingInterval);
            }
        },
        doneTyping: function() {
            if(this.typingTimer!=null && this.header_status.text_filter.length>2) {
                this.header_status_.text_filter = this.header_status.text_filter;
            }
        }
    },
    computed: {
        childsExist: function() {
            return this.header_status_.root_combo_filter?(this.header_status_.root_combo_filter['children'].length>0):false;
        },
        childrens: function() {
            return this.header_status_.root_combo_filter['children'];
        }
    },
    created: function() {
        this.root_combo_filter = "";
    }
}
</script>

<style scoped>

</style>